import { callAuthorizedGraphQLEndpoint } from '../../Module/graphQL'

const getChannels = async () => {
  const gql = `
    query{
      chatChannels{
        nodes{
          id
          subject
          lastMessage
          date
        }
      }
    }
  `
  return callAuthorizedGraphQLEndpoint(gql)
}

const getAdminsByCountryId = async countryId => {
  const gql = `
      query ($countryId:ID!) {
        admins(countryId:$countryId){
          totalCount
          edges{
            node {
              id
              firstName
              lastName
              profilePicture
              role
              cityId
              status
            }
          }
        }
      }
  `
  const res = await callAuthorizedGraphQLEndpoint(gql, { countryId })

  const result = await res.json()

  return result
}

const getCityManagesByCityId = async cityId => {
  const gql = `
      query ($cityId:ID!) {
      cityManagers(cityId:$cityId){
        totalCount
        edges{
          node {
            id
            firstName
            lastName
            profilePicture
            role
            cityId
            status
          }
        }
      }
    }
  `
  const res = await callAuthorizedGraphQLEndpoint(gql, { cityId })

  const result = await res.json()

  return result
}

const getCityById = async id => {
  const gql = `
      query ($id:ID!) {
        city(id: $id){
        name
        country{
          id
        }
      }
    }
  `
  const res = await callAuthorizedGraphQLEndpoint(gql, { id })

  const result = await res.json()

  return result
}

export {
  getChannels,
  getAdminsByCountryId,
  getCityManagesByCityId,
  getCityById,
}
